import { ProposalStatus } from '../api/portal-estimates.api';

export const ProposalStatusText: Record<ProposalStatus, string> = {
    [ProposalStatus.Open]: 'Ready to sign',
    [ProposalStatus.Accepted]: 'Accepted',
    [ProposalStatus.Dismissed]: 'Dismissed',
};

export const ProposalStatusColor: Record<ProposalStatus, string> = {
    [ProposalStatus.Open]: 'warning',
    [ProposalStatus.Accepted]: 'success',
    [ProposalStatus.Dismissed]: 'critical',
};

export const ProposalStatusTagSubtle = {
    [ProposalStatus.Open]: true,
    [ProposalStatus.Accepted]: true,
    [ProposalStatus.Dismissed]: true,
};
